import '@picocss/pico/css/pico.min.css';
import './styles.css';
import './monaco';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import { createBrowserRouter, RouterProvider } from 'react-router';
import { makeStore } from './app/store';
import { routes } from './routes';

const container = document.getElementById('root');
if (container === null) {
  throw new Error('index.html must contain #root');
}

createRoot(container).render(
  <StrictMode>
    <Provider store={makeStore()}>
      <RouterProvider router={createBrowserRouter(routes)} />
    </Provider>
  </StrictMode>,
);
